import { useContext } from "react";
import { IPastRunsContext, PastRunsContext } from "../contexts/pastRuns";

/**
 * Reads the shared "pastRuns" state and cache buster from PastRunsProvider.
 */
export const usePastRuns = (): IPastRunsContext => {
  const context = useContext(PastRunsContext);

  if (!context) {
    throw new Error("usePastRuns must be used within a PastRunsProvider");
  }

  return context;
};

export default usePastRuns;
